var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDatePrimaryBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66309 1V2.40191",
    stroke: "#001698",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34424 1V2.40191",
    stroke: "#001698",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32117 1.59083H9.661C10.0104 1.59083 10.3455 1.72963 10.5926 1.97671C10.8397 2.22379 10.9785 2.5589 10.9785 2.90832V9.97657C10.9785 10.327 10.8393 10.663 10.5915 10.9108C10.3438 11.1585 10.0077 11.2977 9.65732 11.2977H2.3175C1.96807 11.2977 1.63296 11.1589 1.38589 10.9119C1.13881 10.6648 1 10.3297 1 9.98025V2.90832C0.999999 2.735 1.0342 2.56338 1.10064 2.40329C1.16708 2.2432 1.26445 2.0978 1.38718 1.97541C1.50991 1.85302 1.65559 1.75605 1.81586 1.69006C1.97613 1.62406 2.14785 1.59034 2.32117 1.59083V1.59083Z",
    stroke: "#001698",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00342 4.06787H11.0003",
    stroke: "#001698",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatePrimaryBlue);
export default __webpack_public_path__ + "static/media/datePrimaryBlue.04ece325676d652688a62a55e9b13a66.svg";
export { ForwardRef as ReactComponent };